<template>
    <div v-show="show" class="common-popup-bg">
        <div class="common-popup">
            <i class="common-popup-close el-icon-close" @click="close"></i>
            <el-tabs class="tabs1 common-el-tab-flex" type="border-card" v-model="activeName">
                <el-tab-pane class="pane1" label="俱乐部渠道配置" name="clubTab">
                    <comp-club-config :info="info" ref="clubConfig"/>
                </el-tab-pane>
                <el-tab-pane label="充值配置" name="topUpTab">
                    <el-tabs
                            v-if="activeName ==='topUpTab'"
                            class="tabs"
                            tab-position="left"
                            v-model="topUpTabActiveName"
                            @tab-click="tabClick">
                        <el-tab-pane
                                v-for="(item,index) of channelPayment"
                                :key="'topUpTab'+item.code"
                                :label="item.name"
                                :name="'topUpTab-'+index">
                            <comp-top-up-list ref="channel" :info="info" :paymentCode="item.code"/>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="提现配置" name="withdrawalTab">
                    <el-tabs
                            v-if="activeName ==='withdrawalTab'"
                            class="tabs"
                            tab-position="left"
                            v-model="withdrawalTabActiveName"
                            @tab-click="tabClick">
                        <el-tab-pane
                                v-for="(item,index) of channelPayment"
                                :key="'withdrawalTab'+item.code"
                                :label="item.name"
                                :name="'withdrawalTab-'+index">
                            <comp-withdrawal-list ref="channel" :info="info" :paymentCode="item.code"/>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
                <el-tab-pane class="pane1" label="渠道信息配置" name="infoTab">
                    <comp-info-config :info="info" ref="infoConfig" @my-submit="$emit('my-update',$event)"/>
                </el-tab-pane>
                <el-tab-pane class="common-el-tab-flex" label="提现支持银行卡配置" name="bankCardTab">
                    <comp-withdrawal-bank-card-config class="common-el-tab-flex" ref="bankCardConfig" :info="info"/>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import compClubConfig from './compClubConfig'
    import compTopUpList from './compTopUpList'
    import compWithdrawalList from './compWithdrawalList'
    import compInfoConfig from './compInfoConfig'
    import compWithdrawalBankCardConfig from './compWithdrawalBankCardConfig'

    export default {
        name: 'compSet',
        components: {
            compClubConfig,
            compTopUpList,
            compWithdrawalList,
            compInfoConfig,
            compWithdrawalBankCardConfig
        },
        props: {
            info: Object
        },
        data() {
            return {
                show: false,
                activeName: 'clubTab',
                topUpTabActiveName: 'topUpTab-0',
                withdrawalTabActiveName: 'withdrawalTab-0',
            }
        },
        computed: {
            ...mapState('payChannel', ['channelPayment']),
        },
        watch: {
            activeName(newVal) {
                if (newVal === 'bankCardTab') {
                    this.$refs.bankCardConfig.getList()
                }
            }
        },
        methods: {
            close() {
                this.show = false;
                this.$refs.clubConfig.searchKey = '';
                this.$refs.clubConfig.searchClubId = '';
                this.$refs.clubConfig.searchUnionId = '';
                this.$refs.infoConfig.clearForm();
                this.activeName = 'clubTab';
                this.topUpTabActiveName = 'topUpTab-0';
                this.withdrawalTabActiveName = 'withdrawalTab-0';
                this.$emit('my-close');
            },
            tabClick(e) {
                e.$children[0].getDetail();
            }
        }
    }
</script>
<style lang="scss" scoped>
    .common-popup {
        border: none;
        box-shadow: none;
    }

    .tabs1 {
        width: 840px;
        height: 500px;
        :global(.el-tabs__content) {
            flex: 1;
        }
    }

    .tabs {
        height: 430px;
        width: 100%;
    }

</style>